// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"AlertPop_ConfirmationPop__TD4iw","modalBody":"AlertPop_modalBody__vgytO","modalMessage":"AlertPop_modalMessage__ioQn4","modalButton":"AlertPop_modalButton__WNACK"};